import React, { useMemo } from 'react';
import '../../../../Stylesheets/Dashboard/Metrics.css';

const Metrics = ({ projects = [], metrics }) => {
  // Active Projects
  const activeProjects = useMemo(() => {
    if (typeof metrics?.activeProjects === 'number') return metrics.activeProjects;
    if (Array.isArray(projects) && projects.length) {
      const hasStatus = projects.some(p => p?.status);
      return hasStatus ? projects.filter(p => p.status === 'Active').length : projects.length;
    }
    return 0;
  }, [metrics, projects]);

  // Total Workers (supports different shapes coming from API)
  const totalWorkers = useMemo(() => {
    if (typeof metrics?.totalWorkers === 'number') return metrics.totalWorkers;
    if (typeof metrics?.labor?.totalWorkers === 'number') return metrics.labor.totalWorkers;
    return 0;
  }, [metrics]);

  // Total Materials Used (supports different shapes)
  const totalMaterials = useMemo(() => {
    if (typeof metrics?.totalMaterialsUsed === 'number') return metrics.totalMaterialsUsed;
    if (typeof metrics?.materials?.usedUnits === 'number') return metrics.materials.usedUnits;
    if (typeof metrics?.materials?.totalUnits === 'number') return metrics.materials.totalUnits;
    return 0;
  }, [metrics]);

  return (
    <div className="Overview-metrics-container">
      <div className="fancy-metric-card theme-purple">
        <span className="circle circle1"></span>
        <span className="circle circle2"></span>
        <span className="circle circle3"></span>
        <span className="circle circle4"></span>
        <p className="Overview-metric-title">Active Projects</p>
        <h1 className="Overview-metric-value">
          {activeProjects} <span>{activeProjects === 1 ? 'Site' : 'Sites'}</span>
        </h1>
      </div>

      <div className="fancy-metric-card theme-blue">
        <span className="circle circle1"></span>
        <span className="circle circle2"></span>
        <span className="circle circle3"></span>
        <span className="circle circle4"></span>
        <p className="Overview-metric-title">Total Workers</p>
        <h2 className="Overview-metric-value">
          {totalWorkers} <span>{totalWorkers === 1 ? 'Worker' : 'Workers'}</span>
        </h2>
      </div>

      <div className="fancy-metric-card theme-orange">
        <span className="circle circle1"></span>
        <span className="circle circle2"></span>
        <span className="circle circle3"></span>
        <span className="circle circle4"></span>
        <p className="Overview-metric-title">Total Material Used</p>
        <h2 className="Overview-metric-value">
          {totalMaterials} <span>Units</span>
        </h2>
      </div>
    </div>
  );
};

export default Metrics;
